import gql from 'graphql-tag';

export const UPDATE_DEAL_CLOSURE_DATE = gql`
  mutation UpdateDealClosureDate($input: UpdateDealClosureDateInput!) {
    bpf {
      result: updateDealClosureDate(input: $input) {
        error
        success
        entity {
          id
          parentId
          parentType
          closedDateTime
          createdDateTime
          updatedDateTime
        }
      }
    }
  }
`;
